import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import './ForgotPassword.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/api/v1/auth/forgot-password/', { email });
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fp-page">
      <div className="fp-container">
        <div className="fp-header">
          <div className="fp-logo">
            <div className="logo-square">LS</div>
            <div className="logo-text">
              <div className="logo-title">LegalSoft</div>
              <div className="logo-subtitle">AI Matchmaker</div>
            </div>
          </div>
        </div>

        <div className="fp-content">
          {submitted ? (
            <div className="fp-success">
              <div className="fp-success-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="#8b5cf6" />
                </svg>
              </div>
              <h1 className="fp-title">Check your email</h1>
              <p className="fp-subtitle">
                If an account exists for <strong>{email}</strong>, we've sent a password reset link.
                The link expires in 1 hour.
              </p>
              <Link to="/login" className="fp-back-link">
                ← Back to sign in
              </Link>
            </div>
          ) : (
            <>
              <div className="fp-icon-wrap">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" fill="#8b5cf6" />
                </svg>
              </div>
              <h1 className="fp-title">Forgot your password?</h1>
              <p className="fp-subtitle">
                Enter your email address and we'll send you a link to reset your password.
              </p>

              {error && (
                <div className="fp-error">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="currentColor" />
                  </svg>
                  <span>{error}</span>
                </div>
              )}

              <form onSubmit={handleSubmit} className="fp-form">
                <div className="fp-form-group">
                  <label htmlFor="email" className="fp-label">Email address</label>
                  <input
                    type="email"
                    id="email"
                    className="fp-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@lawfirm.com"
                    required
                    disabled={loading}
                    autoFocus
                  />
                </div>

                <button type="submit" className="fp-button" disabled={loading}>
                  {loading ? 'Sending…' : 'Send Reset Link'}
                </button>
              </form>

              <Link to="/login" className="fp-back-link">
                ← Back to sign in
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
